/**
 * Labstep
 *
 * @module components/Notification/Card/Preview
 * @desc Preview Card for single notification
 */

import { CommentSideMenu } from 'labstep-web/components/Comment/SideMenu';
import { NotificationCardPreviewDesktop } from 'labstep-web/components/Notification/Card/Preview/Desktop';
import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import { Notification as NotificationModel } from 'labstep-web/models/notification.model';
import { generateNewDateString } from 'labstep-web/services/date.service';
import type React from 'react';
import type {
  NotificationCardPreviewContainerProps,
  NotificationCardPreviewProps,
} from './types';

const NotificationCardPreview: React.FC<
  NotificationCardPreviewProps
> = ({ notification, update }) => {
  const markAsRead = () => {
    update({ read_at: generateNewDateString() });
  };

  const preview = (
    <NotificationCardPreviewDesktop notification={notification} />
  );

  if (
    notification.metadata &&
    notification.metadata.parent_thread_id
  ) {
    return (
      <CommentSideMenu
        children={preview}
        markAsRead={markAsRead}
        notification={notification}
      />
    );
  }

  return <div onClick={markAsRead}>{preview}</div>;
};

export const NotificationCardPreviewContainer = (
  props: NotificationCardPreviewContainerProps,
) => (
  <EntityUpdateContainer
    entityName={NotificationModel.entityName}
    id={props.notification.id}
  >
    {(containerProps) => (
      <NotificationCardPreview {...props} {...containerProps} />
    )}
  </EntityUpdateContainer>
);
